import './App.module.css'
import './vars.css'
import './bugfixes.css'

import React, { useEffect, useState } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { Dashboard } from './pages/dashboard/Dashboard'
import { Services } from './services/services'
import { ObjectsPage } from './pages/service/Objects'
import { ObjectPage } from './pages/service/objects/Object'
import { QRTag } from './pages/qr/Tag'
import { QRActivate } from './pages/qr/Activate'
import { TeltonikaPage } from './pages/service/Teltonika'
import { TeltonikaDevicePage } from './pages/service/teltonika/Device'
import { MachinesPage } from './pages/machines/Machines'
import { MachinePage } from './pages/machines/Machine'
import { LoginPage } from './pages/users/Login'
import { LogoutPage } from './pages/users/Logout'
import { RegistrationWizard } from './pages/users/registration/wizard'
import { ResetPasswordWizard } from './pages/users/resetpassword/wizard'
import { CurrentSession } from './services/repository/session'
import { SuperAdminUsersPage } from './pages/for/superadmin/users/Users'
import { NFCReaderPage } from './components/nfc/reader'
import { SuperAdminCompanysPage } from './pages/for/superadmin/companies/Companies'
import { QRScannerPage } from './components/qr/scanner'
import { SuperAdminMachinesPage } from './pages/for/superadmin/machines/Machines'
import { CommunalMachineDashboard } from './pages/communal/machine/Dashboard'
import { LoginProvider, useLogin } from './context/login'
import { UniversalQRScannerPage } from './pages/communal/tools/qr/scanner'
import { Translates } from './services/repository/i18n'
import { CommunalMachineFailures } from './pages/communal/machine/FailureList'
import { GlobalModalContainer, ModalProvider } from './components/modal/Modal'
import { SuperadminTeltonikaDevicePage } from './pages/for/superadmin/teltonika/Device'
import { MapPage } from './pages/communal/Map'
import { QRGenerator } from './pages/for/superadmin/qr/Generator'
import { CommunalMachineDetails } from './pages/communal/machine/Details'
import { CommunalMachineFailuresMap } from './pages/communal/FailureMap'
import { CommunalHitsMap } from './pages/communal/HitMap'
import { StartAddFailurePage } from './pages/communal/machine/failures/add/Main'
import { AddFailurePage1 } from './pages/communal/machine/failures/add/Page1'
import { AddFailurePage2 } from './pages/communal/machine/failures/add/Page2'
import { AddFailureGallery } from './pages/communal/machine/failures/add/Gallery'
import { AddFailureDescription } from './pages/communal/machine/failures/add/Description'
import { Redirect } from './pages/system/Redirect'
import { Roles } from './services/repository/users'
import { ServicemanMachinesPage } from './pages/for/serviceman/machines/Machines'

import { SupportPage } from './env/contact/Support'
import { ContactPage } from './env/contact/Contact'
import { CommunalMachineBuyPage } from './env/contact/machine/Buy'
import { CommunalMachineRentPage } from './env/contact/machine/Rent'
import { StartMachineFilesWizard } from './pages/communal/machine/files/uploadWizard/Main'
import { MachineFilesWizardStep1 } from './pages/communal/machine/files/uploadWizard/Step1'
import { CommunalMachineFilesDashboard } from './pages/communal/machine/files/Dashboard'
import { MachineFilesWizardStep2 } from './pages/communal/machine/files/uploadWizard/Step2'
import { SupportWizardStep1 } from './pages/communal/support/wizard/Step1'
import { SupportWizardStep2 } from './pages/communal/support/wizard/Step2'
import { SupportWizard } from './pages/communal/support/wizard/Main'
import { SupportWizardStep3 } from './pages/communal/support/wizard/Step3'
import { SupportWizardStep4 } from './pages/communal/support/wizard/Step4'
import { SupportWizardStep5 } from './pages/communal/support/wizard/Step5'
import { SuperAdminSupportQuestionPage } from './pages/for/superadmin/support/Questions'
import { SuperAdminUserGroupsPage } from './pages/for/superadmin/usergroups/groups'
import { MyMachinesPage } from './pages/communal/my/MyMachines'
import { CommunalMyMachineFailuresMap } from './pages/communal/my/MyFailureMap'
import { CommunalMyHitsMap } from './pages/communal/my/MyHitMap'
import { MyMapPage } from './pages/communal/my/MyMap'
import { BatteryMapPage } from './pages/communal/BatteryMap'
import { MyBatteryMapPage } from './pages/communal/my/MyBatteryMap'
import { CommunalMachineHitSearchPage } from './pages/communal/machine/hits/HitSearch'
import { MachinesStatistics } from './pages/communal/statistics/machinestatistic/Dashboard'
import { CommunalMachineHitsMap } from './pages/communal/machine/HitMap'
import { SuperAdminMachineTypesPage } from './pages/for/superadmin/machinetype/MachineType'
import { CommunalMachinePathMap } from './pages/communal/machine/PathMap'
import { ManagerCardsPage } from './pages/communal/cards/Manager'
import { CompanyManagerMyMachinesPage } from './pages/for/companymanager/my/MyMachines'
import { UsersStatistics } from './pages/communal/statistics/userstatistic/Dashboard'
import { Spinner } from './components/spinner'
import { AppContext, useAppContext } from './context/app'
import { MachineTypeMapPage } from './pages/communal/MachineTypeMap'
import { UsersReportWizard } from './pages/communal/my/reports/usersranking/wizard/Main'
import { UsersReportWizardResult } from './pages/communal/my/reports/usersranking/wizard/Result'
import { UsersReportWizardStep1 } from './pages/communal/my/reports/usersranking/wizard/Step1'
import { UserManagerCardsPage } from './pages/communal/cards/UserManager'
import { MachineChecklistWizard, MachineChecklistWizardPage } from './pages/communal/machine/checklist/wizard/Main'

const NoFound = () => {
  const { session, translates } = useAppContext()
  const { redirectToLogin } = useLogin()
  const navigate = useNavigate()

  useEffect(() => {
    if (session) {
      setTimeout(() => {
        navigate('/')
      }, 5000)
    } else {
      redirectToLogin({
        redirectTo: window.location.pathname + window.location.search + window.location.hash
      })
    }
  }, [session])

  return <>
    <h2>{translates ? translates.for('errors.page_not_found') : 'Page not found'}</h2>
  </>
};

export const App = ({ services }: { services: Services }) => {
  const [session, setSession] = useState<CurrentSession | null | undefined>(undefined)
  const [translates, setTranslates] = useState<Translates>()

  useEffect(() => {
    services.i18n.get('main').then(setTranslates)
  }, [])

  useEffect(() => {
    const id = services.session.listen((session) => {
      setSession(session)
      const unsafeWindow = window as any;
      if (unsafeWindow.finishLoading) {
        unsafeWindow.finishLoading()
      }
    })
    return () => {
      services.session.remove(id)
    }
  })

  const forLoggedInUsers = () => {
    if (!session) {
      return
    }
    return <>
      {/* Dashboard */}
      <Route path='/dashboard' element={<Dashboard />} />

      {/* Admin panel */}
      {/* <Route path='/admin/companies' element={<AdminCompaniesPage services={services} />} /> */}
      {/* <Route path='/admin/companies/:cid' element={<AdminCompanyPage services={services} />} /> */}

      <Route path='/companies/:cid/machines' element={<MachinesPage services={services} />} />
      <Route path='/machines/:mid' element={<MachinePage services={services} />} />

      {/* Servicman panel */}
      {/* <Route path='/service/dashboard' element={<ServiceDashboard services={services}/>} /> */}
      <Route path='/service/objects' element={<ObjectsPage services={services} />} />
      <Route path='/service/objects/:oid' element={<ObjectPage services={services} />} />
      <Route path='/service/teltonika' element={<TeltonikaPage services={services} session={session} />} />
      <Route path='/service/teltonika/:imei' element={<TeltonikaDevicePage services={services} />} />

      {/* communal */}
      <Route path='/communal/qrscanner' element={<UniversalQRScannerPage services={services} session={session} />} />
      <Route path='/communal/machine/:mid/failures' element={<CommunalMachineFailures services={services} session={session} />} />
      <Route path='/communal/machine/:mid/hits' element={<CommunalMachineHitSearchPage services={services} session={session} />} />
      <Route path='/communal/machine/:mid/hitmap' element={<CommunalMachineHitsMap services={services} session={session} />} />
      <Route path='/communal/machine/:mid/pathmap' element={<CommunalMachinePathMap services={services} session={session} />} />
      <Route path='/communal/machine/:mid/teltonika' element={<SuperadminTeltonikaDevicePage services={services} session={session} />} />
      <Route path='/communal/failures/map' element={<CommunalMachineFailuresMap services={services} session={session} />} />
      <Route path='/communal/hit/map' element={<CommunalHitsMap services={services} session={session} />} />
      <Route path='/communal/map' element={<MapPage services={services} session={session} />} />
      <Route path='/communal/machinetype/map' element={<MachineTypeMapPage services={services} session={session} />} />
      <Route path='/communal/battery/map' element={<BatteryMapPage services={services} session={session} />} />

      {/* <Route path='/communal/machine/:machineid/files/upload/page2' element={<AddFailurePage2 services={services} session={session} />} />
      <Route path='/communal/machine/:machineid/files/upload/gallery' element={<AddFailureGallery services={services} session={session} />} />
      <Route path='/communal/machine/:machineid/files/upload/description' element={<AddFailureDescription services={services} session={session} />} /> */}

      {/* My machines */}
      <Route path='/communal/my/failures/map' element={<CommunalMyMachineFailuresMap services={services} session={session} />} />
      <Route path='/communal/my/hit/map' element={<CommunalMyHitsMap services={services} session={session} />} />
      <Route path='/communal/my/machines' element={<MyMachinesPage services={services} session={session} />} />
      <Route path='/communal/my/battery/map' element={<MyBatteryMapPage services={services} session={session} />} />
      <Route path='/communal/my/map' element={<MyMapPage services={services} session={session} />} />

      {/* Users Ranking - Report - Wizard */}
      <Route path='/communal/machine/:mid/checklist/wizard' element={<MachineChecklistWizardPage />} />

      {/* QR codes */}
      <Route path='/qr/generator' element={<QRGenerator services={services} session={session} />} />
      <Route path='/qr/activate/:id' element={<QRActivate />} />

      {/* Cards */}
      <Route path='/communal/cards/manager' element={<ManagerCardsPage services={services} session={session} />} />
      <Route path='/communal/cards/manager/foruser/:user' element={<UserManagerCardsPage services={services} session={session} />} />

      {/* Dashboards */}
      <Route path='/communal/statistics/machines' element={<MachinesStatistics services={services} session={session} />} />
      <Route path='/communal/statistics/users' element={<UsersStatistics services={services} session={session} />} />

      {/* Users Ranking - Report - Wizard */}
      <Route path='/communal/report/usersranking/wizard' element={<UsersReportWizard services={services} session={session} />} />
      <Route path='/communal/report/usersranking/wizard/page1' element={<UsersReportWizardStep1 />} />
      <Route path='/communal/report/usersranking/wizard/result' element={<UsersReportWizardResult />} />
    </>
  }

  const forSuperAdmin = () => {
    if (!session || session.user.role !== Roles.SuperAdmin) {
      return
    }
    return <>
      <Route path='/superadmin/users' element={<SuperAdminUsersPage services={services} session={session} />} />
      <Route path='/superadmin/nfcreader' element={<NFCReaderPage services={services} session={session} />} />
      <Route path='/superadmin/companies' element={<SuperAdminCompanysPage services={services} session={session} />} />
      <Route path='/superadmin/machines' element={<SuperAdminMachinesPage services={services} session={session} />} />
      <Route path='/superadmin/machinetypes' element={<SuperAdminMachineTypesPage services={services} session={session} />} />
      <Route path='/superadmin/qrscanner' element={<QRScannerPage services={services} session={session} />} />
      <Route path='/superadmin/support/questions' element={<SuperAdminSupportQuestionPage services={services} session={session} />} />

      {/* User groups */}
      <Route path='/superadmin/usergroups' element={<SuperAdminUserGroupsPage services={services} session={session} />} />
    </>
  }

  const forCompanyManager = () => {
    if (!session || session.user.role !== Roles.CompanyManager) {
      return
    }
    return <>
      <Route path='/companymanager/my/machines' element={<CompanyManagerMyMachinesPage services={services} session={session} />} />
    </>
  }

  const forServiceman = () => {
    if (!session || session.user.role !== Roles.Serviceman) {
      return
    }
    return <>
      <Route path='/serviceman/machines' element={<ServicemanMachinesPage services={services} session={session} />} />
    </>
  }

  if (session === undefined) {
    return <Spinner />
  }

  return <div className='app-wrap'>
    <AppContext.Provider value={{ services, session, translates }}>
      <ModalProvider>
        <LoginProvider services={services}>
          <div className='app'>
            <Routes>
              {forLoggedInUsers()}
              {forSuperAdmin()}
              {forServiceman()}
              {forCompanyManager()}

              <Route path='/' element={<LoginPage services={services} />} />
              <Route path='/login' element={<LoginPage services={services} />} />
              <Route path='/registration' element={<RegistrationWizard services={services} />} />
              <Route path='/resetpassword' element={<ResetPasswordWizard services={services} />} />

              <Route path='/qr/tag/:id' element={<QRTag services={services} />} />

              <Route path='*' element={<NoFound />} />

              <Route path='/communal/machine/:mid' element={<CommunalMachineDashboard services={services} session={session} />} />

              <Route path='/communal/machine/:machineid/failures/add' element={<StartAddFailurePage services={services} session={session} />} />
              <Route path='/communal/machine/:machineid/failures/add/page1' element={<AddFailurePage1 services={services} session={session} />} />
              <Route path='/communal/machine/:machineid/failures/add/page2' element={<AddFailurePage2 services={services} session={session} />} />
              <Route path='/communal/machine/:machineid/failures/add/gallery' element={<AddFailureGallery services={services} session={session} />} />
              <Route path='/communal/machine/:machineid/failures/add/description' element={<AddFailureDescription services={services} session={session} />} />
              <Route path='/communal/machine/:mid/rent' element={<CommunalMachineRentPage services={services} session={session} />} />
              <Route path='/communal/machine/:mid/buy' element={<CommunalMachineBuyPage services={services} session={session} />} />

              <Route path='/communal/contact' element={<ContactPage services={services} />} />
              <Route path='/communal/support' element={<SupportPage services={services} />} />

              {/* system */}
              <Route path='/logout' element={<LogoutPage services={services} />} />
              <Route path='/communal/machine/:mid/details' element={<CommunalMachineDetails services={services} session={session} />} />
              <Route path='/communal/redirect' element={<Redirect services={services} />} />

              {/* machine files */}
              <Route path='/communal/machine/:machineid/files' element={<CommunalMachineFilesDashboard services={services} session={session} />} />
              <Route path='/communal/machine/:machineid/files/upload' element={<StartMachineFilesWizard services={services} session={session} />} />
              <Route path='/communal/machine/:machineid/files/upload/page1' element={<MachineFilesWizardStep1 services={services} session={session} />} />
              <Route path='/communal/machine/:machineid/files/upload/page2' element={<MachineFilesWizardStep2 services={services} session={session} />} />

              {/* Support */}
              {/* <Route path='/support/wizard' element={<CommunalMachineFilesDashboard services={services} session={session} />} /> */}
              <Route path='/communal/support/wizard' element={<SupportWizard services={services} session={session} />} />
              <Route path='/communal/support/wizard/page1' element={<SupportWizardStep1 services={services} session={session} />} />
              <Route path='/communal/support/wizard/page2' element={<SupportWizardStep2 services={services} session={session} />} />
              <Route path='/communal/support/wizard/page3' element={<SupportWizardStep3 services={services} session={session} />} />
              <Route path='/communal/support/wizard/page4' element={<SupportWizardStep4 services={services} session={session} />} />
              <Route path='/communal/support/wizard/page5' element={<SupportWizardStep5 services={services} session={session} />} />
            </Routes>
          </div>
        </LoginProvider>
        <GlobalModalContainer />
      </ModalProvider>
    </AppContext.Provider>
  </div>
};
